import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Design-system stylesheet loaded AFTER tailwind so its tokens/base win.
import './styles/dashboard.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
